<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Daftar Member</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Daftar Member</li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto">
                <router-link :to="'/subscriptions'" class="btn add-btn">
                  <i class="fa fa-shopping-cart"></i> Order
                </router-link>
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <!-- <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.period"
                  type="month"
                /> -->
                <a-range-picker allowClear style="border:none !important" class=" pt-3 form-control floating" :ranges="{
                  Kemarin: [
                    $moment().subtract(1, 'day'),
                    $moment().subtract(1, 'day')
                  ],
                  'Hari Ini': [$moment(), $moment()],
                  'Bulan Ini': [
                    $moment().startOf('month'),
                    $moment().endOf('month')
                  ],
                  'Bulan Lalu': [
                    $moment()
                      .subtract(1, 'month')
                      .startOf('month'),
                    $moment()
                      .subtract(1, 'month')
                      .endOf('month')
                  ],
                  '7 Hari Lalu': [
                    $moment().subtract(7, 'day'),
                    $moment().subtract(1, 'day')
                  ],
                  '30 Hari Lalu': [
                    $moment().subtract(30, 'day'),
                    $moment().subtract(1, 'day')
                  ]
                }" format="YYYY-MM-DD" v-model="periode" placeholder="Tgl Join" />
                <!-- <label class="focus-label">Tgl Join</label> -->
              </div>
            </div>
            <!-- <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <select class="form-control" v-model="serverParams.columnFilters.is_confirmed">
                  <option value></option>
                  <option value="y">Confirmed</option>
                  <option value="n">Not Confirmed</option>
                </select>
                <label class="focus-label">Confirmed</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <select class="form-control" v-model="serverParams.columnFilters.is_created_license">
                  <option value></option>
                  <option value="y">Created License</option>
                  <option value="n">Not Created License</option>
                </select>
                <label class="focus-label">Created License</label>
              </div>
            </div> -->
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <div class="input-group">
                  <input class="form-control floating" v-model="serverParams.columnFilters.keywords" type="text"
                    placeholder="Name, Email, Mobile Phone" />
                  <label class="focus-label">Search</label>
                  <div class="input-group-append">
                    <a title="Show search options" class="btn btn-primary" @click="
                      $store.dispatch('utils/setModalData', {
                        showModal: true
                      })
                      " href="#" data-toggle="modal" data-target="#search_form">
                      <i class="fa fa-list"></i>
                      <i class="fa fa-circle" v-if="serverParams.more_search == true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <ModalFilter @clear="resetFilter" @searchData="
              () => {
                serverParams.more_search = true;
                searchData();
              }
            ">
              <template>
                <!-- <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Period</label>
                    <input
                      class="form-control col-md-6"
                      v-model="serverParams.columnFilters.period"
                      type="month"
                    />
                  </div>
                </div> -->
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Tgl Join</label>
                    <div class="col-md-6 px-0">
                      <a-range-picker allowClear :ranges="{
                        Kemarin: [
                          $moment().subtract(1, 'day'),
                          $moment().subtract(1, 'day')
                        ],
                        'Hari Ini': [$moment(), $moment()],
                        'Bulan Ini': [
                          $moment().startOf('month'),
                          $moment().endOf('month')
                        ],
                        'Bulan Lalu': [
                          $moment()
                            .subtract(1, 'month')
                            .startOf('month'),
                          $moment()
                            .subtract(1, 'month')
                            .endOf('month')
                        ],
                        '7 Hari Lalu': [
                          $moment().subtract(7, 'day'),
                          $moment().subtract(1, 'day')
                        ],
                        '30 Hari Lalu': [
                          $moment().subtract(30, 'day'),
                          $moment().subtract(1, 'day')
                        ]
                      }" format="YYYY-MM-DD" v-model="periode" />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Search</label>
                    <!-- <input
                      
                      v-model="serverParams.columnFilters.keywords"
                      type="text"
                      placeholder="Name, Email, Mobile Phone"
                    /> -->
                    <a-input class="form-control col-md-6" placeholder="Name, Email, Mobile Phone"
                      v-model="serverParams.columnFilters.keywords" />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Is Confirmed</label>
                    <!-- <select
                      class="form-control col-md-6"
                      v-model="serverParams.columnFilters.is_confirmed"
                    >
                      <option value=""></option>
                      <option value="y">Yes</option>
                      <option value="n">No</option>
                    </select> -->
                    <a-select v-model="serverParams.columnFilters.is_confirmed" placeholder="Is Confirmed"
                      class="col-md-6 px-0" allowClear>
                      <a-select-option value=""> &nbsp; </a-select-option>
                      <a-select-option value="y"> Yes </a-select-option>
                      <a-select-option value="n"> No </a-select-option>
                    </a-select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Is Created License</label>
                    <!-- <select
                      class="form-control col-md-6"
                      v-model="serverParams.columnFilters.is_created_license"
                    >
                      <option value=""></option>
                      <option value="y">Yes</option>
                      <option value="n">No</option>
                    </select> -->
                    <a-select v-model="serverParams.columnFilters.is_created_license" placeholder="Is Created License"
                      class="col-md-6 px-0" allowClear>
                      <a-select-option value=""> &nbsp; </a-select-option>
                      <a-select-option value="y"> Yes </a-select-option>
                      <a-select-option value="n"> No </a-select-option>
                    </a-select>
                  </div>
                </div>
              </template>
            </ModalFilter>
            <div class="col-sm-6 col-md-3">
              <a href="javascript:void(0)" @click.prevent="searchData" class="btn btn-success btn-block">Search</a>
            </div>

          </div>
          <!-- /Search Filter -->
          <div class="row filter-row">
            <div class="col-md-12">
              <div class="col-sm-6 col-md-3">
                <button :disabled="isLoading" @click="listDataMemberExcel" class="btn btn-sm btn-primary">
                  <i class="fa fa-download"></i> Excel
                </button>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div v-if="linkDownload != ''" class="alert alert-success">Data berhasil dibuat, silakan klik <a
                    :href="linkDownload" target="_blank">link</a> berikut jika download otomatis tidak berfungsi. <a
                    class="text-danger" @click="closeMessageLinkDownload"><i class="fa fa-remove"></i></a></div>

                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center" style="width:100px;">Name</th>
                      <th class="text-center">Email</th>
                      <th class="text-center">Mobile Phone</th>
                      <th class="text-center">Join Date</th>
                      <!-- <th class="text-center">Confirmed Date</th> -->
                      <th class="text-center">Status Confirmed</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="7">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td class="text-right">{{ row.number }}</td>
                        <td>{{ row.member_name }}</td>
                        <td>{{ row.member_email }}</td>
                        <td>{{ row.member_mobilephone }}</td>
                        <td>
                          {{
                            $moment
                              .unix(row.member_join_datetime)
                              .format("YYYY-MM-DD HH:mm:ss")
                          }}
                        </td>
                        <td>
                          <span :class="row.member_is_confirmed_status == '1'
                            ? 'text text-success'
                            : 'text text-danger'
                            ">{{
                              row.member_is_confirmed_status == "1"
                                ? "Confirmed"
                                : "Belum Confirmed"
                            }}</span><br />
                          <small>{{ row.member_is_confirmed_datetime }}</small>
                        </td>
                        <td class="text-center">
                          <div class="dropdown dropdown-action">
                            <a
                              href="#"
                              class="action-icon dropdown-toggle"
                              data-toggle="dropdown"
                              data-boundary="viewport"
                              aria-expanded="false"
                              :style="verifyModal.loading ? 'pointer-events:none;opacity:.5;' : ''"
                            >
                              <i class="material-icons">more_vert</i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a
                                v-if="String(row.member_is_confirmed_status) !== '1'"
                                href="#"
                                class="dropdown-item"
                                @click.prevent="openMemberAction(row, 'confirm')"
                              >
                                <i class="fa fa-check-circle m-r-5"></i> Konfirmasi Akun
                              </a>
                              <a
                                href="#"
                                class="dropdown-item"
                                @click.prevent="openMemberAction(row, 'impersonate')"
                              >
                                <i class="fa fa-user-secret m-r-5"></i> Login sebagai Member
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-if="loading">
                      <tr>
                        <td colspan="7">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="7" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
                v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input style="width:100px;" min="1" type="number" v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))" class />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                class="footer__navigation__page-btn" :class="'btn ' +
                {
                  disabled:
                    parseInt(currentPage) + 1 >
                    Math.ceil(totalRecords / serverParams.perPage)
                }
                  ">
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <modal-admin-password-verify
      :visible="verifyModal.visible"
      :loading="verifyModal.loading"
      :error-message="verifyModal.error"
      :member-name="verifyMemberName"
      :action-label="verifyActionLabel"
      @close="closeVerifyModal"
      @submit="onVerifyAdminPassword"
    ></modal-admin-password-verify>
  </div>
</template>

<script>
import {
  convertUTCDatetimeToUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  getWhatsappNumberFromJid,
  formatPriceRupiah
} from "@/utils/helper";
// import { DatePicker } from "ant-design-vue";
import { Skeleton } from "vue-loading-skeleton";
import ModalFilter from "@/components/ModalFilter";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import ModalAdminPasswordVerify from "@/components/ModalAdminPasswordVerify.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    // DatePicker,
    ModalFilter,
    ModalAdminPasswordVerify
  },
  data() {
    return {
      linkDownload: '',
      isLoading: false,
      loading: false,
      periode: [],
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      verifyModal: {
        visible: false,
        loading: false,
        error: "",
        action: "",
        member: null
      },
      serverParams: {
        columnFilters: {
          period: "",
          keywords: "",
          is_confirmed: "",
          is_created_license: "",
          start_date: "",
          end_date: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  computed: {
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    },
    verifyMemberName() {
      return this.verifyModal.member
        ? this.verifyModal.member.member_name
        : "";
    },
    verifyActionLabel() {
      if (this.verifyModal.action === "confirm") {
        return "Konfirmasi Akun";
      }
      if (this.verifyModal.action === "impersonate") {
        return "Login sebagai Member";
      }
      return "";
    }
  },
  watch: {
    periode(val) {
      console.log(val);
      if (val.length) {
        this.serverParams.columnFilters.start_date = this.$moment(
          val[0]
        ).format("YYYY-MM-DD");
        this.serverParams.columnFilters.end_date = this.$moment(val[1]).format(
          "YYYY-MM-DD"
        );
        console.log(this.serverParams.columnFilters);
      } else {
        this.serverParams.columnFilters.start_date = "";
        this.serverParams.columnFilters.end_date = "";
      }
    }
  },
  created() {
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    closeMessageLinkDownload() {
      this.linkDownload = '';
    },
    listDataMemberExcel() {
      this.isLoading = true;
      this.$store
        .dispatch("member/listDataMemberExcel", this.serverParams)
        .then(response => {
          this.isLoading = false;
          this.linkDownload = response.data;
          if (this.linkDownload != '') {
            window.open(this.linkDownload, '_blank').focus();
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    convertUTCDatetimeToUnix(value) {
      return convertUTCDatetimeToUnix(value);
    },
    formatPriceRupiah(value) {
      return formatPriceRupiah(value);
    },

    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    resetFilter() {
      this.serverParams.columnFilters = {
        period: "",
        keywords: "",
        feature: "",
        is_online_status: "",
        start_date: "",
        end_date: "",
        license_phone_number: ""
      };
      this.serverParams.more_search = false;
      this.periode = [];
      this.searchData();
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("member/listDataMember", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          console.log(data.data);
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    openMemberAction(row, action) {
      if (this.verifyModal.loading) {
        return;
      }
      if (
        action === "confirm" &&
        String(row.member_is_confirmed_status) === "1"
      ) {
        this.$fire({
          title: "Info",
          text: "Akun member sudah berstatus Confirmed.",
          type: "info",
          timer: 2500
        });
        return;
      }

      this.verifyModal.member = row;
      this.verifyModal.action = action;
      this.verifyModal.error = "";
      this.verifyModal.visible = true;

      // Tutup dropdown Bootstrap yang sedang terbuka.
      if (typeof window.$ !== "undefined") {
        window.$(".dropdown-menu.show").removeClass("show");
        window.$(".dropdown-toggle").attr("aria-expanded", "false");
      }
    },
    closeVerifyModal() {
      if (this.verifyModal.loading) {
        return;
      }
      this.verifyModal.visible = false;
      this.verifyModal.error = "";
      this.verifyModal.action = "";
      this.verifyModal.member = null;
    },
    async resolveAdminUsername() {
      const session = this.memberSessionArr;
      if (session && session.email) {
        return session.email;
      }
      const response = await this.$store.dispatch("login/getProfile");
      return response && response.data && response.data.email
        ? response.data.email
        : "";
    },
    async onVerifyAdminPassword(password) {
      const action = this.verifyModal.action;
      const member = this.verifyModal.member;
      if (!member || this.verifyModal.loading) {
        return;
      }

      this.verifyModal.loading = true;
      this.verifyModal.error = "";

      try {
        const username = await this.resolveAdminUsername();
        if (!username) {
          throw new Error(
            "Email administrator tidak ditemukan. Silakan muat ulang halaman."
          );
        }

        // Validasi ulang kredensial admin tanpa membuat/mengganti token admin.
        await this.$store.dispatch("member/validateAdminCredential", {
          username: username,
          password: password
        });

        if (action === "confirm") {
          await this.submitConfirmMemberAccount(member, password);
        } else if (action === "impersonate") {
          await this.startMemberImpersonation(member, password);
        } else {
          throw new Error("Jenis aksi tidak dikenali.");
        }
      } catch (error) {
        this.verifyModal.error = this.buildActionErrorMessage(error, action);
        console.info("[impersonation][zeus] action failed", {
          action: action,
          httpStatus:
            error && error.response ? error.response.status : null,
          message: this.verifyModal.error
        });
      } finally {
        this.verifyModal.loading = false;
      }
    },
    async submitConfirmMemberAccount(member, password) {
      const memberId = this.resolveMemberId(member);
      const response = await this.$store.dispatch(
        "member/confirmMemberAccount",
        {
          member_id: memberId,
          admin_password: password
        }
      );

      this.verifyModal.visible = false;
      this.verifyModal.member = null;
      this.verifyModal.action = "";

      this.$fire({
        title: "Success",
        text:
          (response && response.msg) ||
          "Akun member berhasil dikonfirmasi.",
        type: "success",
        timer: 2500
      });

      await this.refreshCurrentPage();
    },
    async startMemberImpersonation(member, password) {
      const memberId = this.resolveMemberId(member);
      const response = await this.$store.dispatch(
        "member/createMemberImpersonation",
        {
          member_id: memberId,
          admin_password: password
        }
      );

      const data = (response && response.data) || {};
      const handoffCode = data.handoff_code;

      console.info("[impersonation][zeus] impersonate response", {
        httpStatus: response && response.status,
        hasHandoffCode: !!handoffCode,
        hasUnexpectedToken: !!data.x_auth_token
      });

      if (!handoffCode) {
        if (data.x_auth_token) {
          throw new Error(
            "Response impersonation tidak berisi kode handoff. Periksa versi backend omni."
          );
        }
        throw new Error("Kode handoff sesi member tidak diterima dari server.");
      }

      const baseUrl = process.env.VUE_APP_BASE_URL;
      if (!baseUrl) {
        throw new Error(
          "Konfigurasi VUE_APP_BASE_URL untuk dashboard member tidak tersedia."
        );
      }

      console.info("[impersonation][zeus] redirecting to member handoff", {
        hasBaseUrl: !!baseUrl
      });

      // JWT tidak pernah masuk URL. Yang dibawa hanya kode handoff sekali pakai
      // dengan masa berlaku singkat, dan akan ditukar oleh dashboard member.
      const normalizedBaseUrl = baseUrl.replace(/\/+$/, "");
      window.location.href =
        normalizedBaseUrl +
        "/auth/handoff#code=" +
        encodeURIComponent(handoffCode);
    },
    async refreshCurrentPage() {
      // loadItems() mengubah serverParams.page menjadi offset, jadi set ulang
      // ke nomor halaman 1-based sebelum memuat data.
      this.serverParams.page = this.currentPage;
      await this.loadItems();
    },
    // member_id dari PHP/MySQL dapat berupa string; backend Go memakai int64.
    resolveMemberId(member) {
      const memberId = parseInt(member && member.member_id, 10);
      if (!memberId || isNaN(memberId)) {
        throw new Error("ID member tidak valid.");
      }
      return memberId;
    },
    buildActionErrorMessage(error, action) {
      const fallback =
        action === "confirm"
          ? "Gagal mengonfirmasi akun member. Silakan coba lagi."
          : "Gagal membuat sesi member. Silakan coba lagi.";

      const raw =
        error && error.response && error.response.data && error.response.data.msg
          ? String(error.response.data.msg)
          : error && error.message
            ? String(error.message)
            : "";
      const knownMessages = {
        "Member not found": "Member tidak ditemukan.",
        "Failed to generate member access token":
          "Gagal membuat access token member.",
        "Failed to create member session": "Gagal membuat sesi member.",
        "Failed to create handoff code": "Gagal membuat kode handoff.",
        "Failed to create handoff session": "Gagal menyimpan sesi handoff.",
        "Handoff code has expired": "Kode handoff sudah kedaluwarsa.",
        "Email/PhoneNumber or Password are invalid.":
          "Password administrator tidak valid.",
        "Email or Phone Number is not found":
          "Password administrator tidak valid.",
        "Your account was not confirmed, please check your email or whatsapp to verify.":
          "Akun administrator belum dikonfirmasi.",
        "Password administrator tidak valid.":
          "Password administrator tidak valid.",
        "Email administrator tidak ditemukan. Silakan muat ulang halaman.":
          "Email administrator tidak ditemukan. Silakan muat ulang halaman.",
        "Kode handoff sesi member tidak diterima dari server.":
          "Kode handoff sesi member tidak diterima dari server.",
        "Response impersonation tidak berisi kode handoff. Periksa versi backend omni.":
          "Response impersonation tidak berisi kode handoff. Periksa versi backend omni.",
        "Konfigurasi VUE_APP_BASE_URL untuk dashboard member tidak tersedia.":
          "Konfigurasi URL dashboard member tidak tersedia.",
        "ID member tidak valid.": "ID member tidak valid."
      };

      if (knownMessages[raw]) {
        return knownMessages[raw];
      }
      if (!raw || raw === "Error" || raw === "Network Error") {
        return fallback;
      }
      if (/Cannot read|undefined|timeout/i.test(raw)) {
        return fallback;
      }
      return raw;
    }
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "summary_"
};
</script>



// WEBPACK FOOTER //
// src/views/member/list.vue